import { cachePageInstances } from './page'
import { isSubRoute } from './utils'

declare const MAX_ROUTES: Record<string, string>

export function clearPagesCache(route: string) {
  const deleted: string[] = Object.keys(MAX_ROUTES).filter((subRoute) => isSubRoute(route, subRoute)) ?? []
  deleted.forEach((d) => {
    const pageCode = MAX_ROUTES[d]
    if (pageCode) {
      cachePageInstances.delete(pageCode)
    }
  })
}
